import { NEIGHBORS } from "../data/board-geometry";
import type { Direction } from "../types/common";
import type { Board } from "../types/game-state";

const ALL_DIRECTIONS: readonly Direction[] = ["N", "NE", "SE", "S", "SW", "NW"];

export function getValidRingDestinations(
  board: Board,
  from: string,
): readonly string[] {
  const destinations: string[] = [];

  for (const dir of ALL_DIRECTIONS) {
    let seenMarker = false;
    let cur: string | undefined = NEIGHBORS[from]?.[dir];

    while (cur !== undefined) {
      const cell = board[cur] ?? null;

      if (cell === null) {
        // Empty space
        destinations.push(cur);
        if (seenMarker) {
          // Must stop after first empty space following a marker group
          break;
        }
        // Can continue over empty spaces
      } else if (cell.type === "MARKER") {
        seenMarker = true;
        // Continue scanning — must jump the whole group
      } else {
        // Ring — cannot jump over
        break;
      }

      cur = NEIGHBORS[cur]?.[dir];
    }
  }

  return destinations;
}
